import './App.css';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { NavBarContainer } from '../navBar';
import { CreateActivityModalController } from '../createActivityModal';
import { CreateSkillModalController } from '../createSkillModal';
import { CreateSkillGroupModalController } from '../createSkillGroupModal';

import Activity from '../activity/Activity';
import MediaSearch from '../mediaSearch/MediaSearch';
import AllActivities from '../allActivities/AllActivities';
import AllSkills from '../allSkills/AllSkills';

class App extends Component {

    render() {
        const { page } = this.props;
        let currentPage = <Activity />;

        switch(page) {
            case "mediaSearch":
                currentPage = <MediaSearch />;
                break;
            case "allActivities":
                currentPage = <AllActivities />;
                break;
            case "allSkills":
                currentPage = <AllSkills />;
                break;
            default:
                currentPage = <Activity />;
                break;
        }

        return (
            <div className="main-content">
                <NavBarContainer />
                { currentPage }                
                <CreateActivityModalController key='createactivity' />
                <CreateSkillModalController key='createskill' />
                <CreateSkillGroupModalController key='createskillgroup'/>
            </div>
        )
    }
}

App.propTypes = {
    scene: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    scene: state.scene.current,
    page: state.nav.page
});

export default connect(
    mapStateToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/app/App.js